import https from '@/utils/https';
import { IApi } from '@/utils/api-types';
import { IJsApiTicketRes } from '@/api/weixin-types';

// 获取url对应微信分享jsapiticket
export const apiJsApiTicketGet: IApi<IJsApiTicketRes, { url: string }> = (params) =>
  https.post('/mall/weixin/getJsApiTicket', params);
